export default "__VITE_ASSET__aeaa967a__"